var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          title: _vm.$t("pages.admin.video.stats.title"),
          "icon-class": "mdi mdi-frequently-asked-questions"
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12 mb-3" }, [
          _c("div", { staticClass: "card shadow-sm" }, [
            _c(
              "div",
              { staticClass: "card-body" },
              [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-5" }, [
                    _c("h5", { staticClass: "card-title" }, [
                      _vm._v(
                        "\n                                " +
                          _vm._s(
                            _vm.$t("pages.admin.video.stats.video_favorites")
                          ) +
                          "\n                            "
                      )
                    ]),
                    _vm._v(" "),
                    _vm.videoTotalFavorited
                      ? _c("div", [
                          _vm._v(
                            "\n                                Total Favorited :\n                                " +
                              _vm._s(_vm.videoTotalFavorited.favorited) +
                              "\n                            "
                          )
                        ])
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-7 text-right" }, [
                    _c("div", { staticClass: "mb-3" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm",
                          class: [
                            _vm.favoritesChartMode === "daily"
                              ? "btn-primary"
                              : "btn-outline-primary"
                          ],
                          on: {
                            click: function($event) {
                              _vm.favoritesChartMode = "daily"
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(
                                _vm.$t(
                                  "pages.locker.my_aform.stats_types.daily"
                                )
                              ) +
                              "\n                                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm",
                          class: [
                            _vm.favoritesChartMode === "weekly"
                              ? "btn-primary"
                              : "btn-outline-primary"
                          ],
                          on: {
                            click: function($event) {
                              _vm.favoritesChartMode = "weekly"
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(
                                _vm.$t(
                                  "pages.locker.my_aform.stats_types.weekly"
                                )
                              ) +
                              "\n                                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm",
                          class: [
                            _vm.favoritesChartMode === "monthly"
                              ? "btn-primary"
                              : "btn-outline-primary"
                          ],
                          on: {
                            click: function($event) {
                              _vm.favoritesChartMode = "monthly"
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(
                                _vm.$t(
                                  "pages.locker.my_aform.stats_types.monthly"
                                )
                              ) +
                              "\n                                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm",
                          class: [
                            _vm.favoritesChartMode === "yearly"
                              ? "btn-primary"
                              : "btn-outline-primary"
                          ],
                          on: {
                            click: function($event) {
                              _vm.favoritesChartMode = "yearly"
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(
                                _vm.$t(
                                  "pages.locker.my_aform.stats_types.yearly"
                                )
                              ) +
                              "\n                                "
                          )
                        ]
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("favorites-chart", {
                  attrs: {
                    mode: _vm.favoritesChartMode,
                    data: _vm.videoFavorites
                  }
                })
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _c("div", { staticClass: "card shadow-sm" }, [
            _c(
              "div",
              { staticClass: "card-body" },
              [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-md-5" }, [
                    _c("h5", { staticClass: "card-title" }, [
                      _vm._v(
                        "\n                                " +
                          _vm._s(
                            _vm.$t("pages.admin.video.stats.video_stats")
                          ) +
                          "\n                            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n                                Total Completed :\n                                " +
                          _vm._s(_vm.videoViewsStats.completed) +
                          "\n                            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        "\n                                Total Viewed : " +
                          _vm._s(_vm.videoViewsStats.views) +
                          "\n                            "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-md-7 text-right" }, [
                    _c("div", { staticClass: "mb-3" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm",
                          class: [
                            _vm.viewsChartMode === "daily"
                              ? "btn-primary"
                              : "btn-outline-primary"
                          ],
                          on: {
                            click: function($event) {
                              _vm.viewsChartMode = "daily"
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(
                                _vm.$t(
                                  "pages.locker.my_aform.stats_types.daily"
                                )
                              ) +
                              "\n                                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm",
                          class: [
                            _vm.viewsChartMode === "weekly"
                              ? "btn-primary"
                              : "btn-outline-primary"
                          ],
                          on: {
                            click: function($event) {
                              _vm.viewsChartMode = "weekly"
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(
                                _vm.$t(
                                  "pages.locker.my_aform.stats_types.weekly"
                                )
                              ) +
                              "\n                                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm",
                          class: [
                            _vm.viewsChartMode === "monthly"
                              ? "btn-primary"
                              : "btn-outline-primary"
                          ],
                          on: {
                            click: function($event) {
                              _vm.viewsChartMode = "monthly"
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(
                                _vm.$t(
                                  "pages.locker.my_aform.stats_types.monthly"
                                )
                              ) +
                              "\n                                "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-sm",
                          class: [
                            _vm.viewsChartMode === "yearly"
                              ? "btn-primary"
                              : "btn-outline-primary"
                          ],
                          on: {
                            click: function($event) {
                              _vm.viewsChartMode = "yearly"
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                                    " +
                              _vm._s(
                                _vm.$t(
                                  "pages.locker.my_aform.stats_types.yearly"
                                )
                              ) +
                              "\n                                "
                          )
                        ]
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("view-chart", {
                  attrs: { mode: _vm.viewsChartMode, data: _vm.videoStats }
                })
              ],
              1
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }